export default "__VITE_ASSET__GyWDg_YX__"